// extracted by mini-css-extract-plugin
export default {"replacements":"EditableText_replacements__9R4k9","form-placeholder":"EditableText_form-placeholder__2nkzF","attachment-list":"EditableText_attachment-list__EwXXU"};